function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Arcade game-info overlay — game artwork + leaderboard.
 * Ranking data still comes from League; Arcade owns presentation.
 */
var ArcadeGameInfoTemplate = require('./game-info.template');
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ArcadeGameInfo = /*#__PURE__*/function () {
  function ArcadeGameInfo(app) {
    var _this = this;
    var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, ArcadeGameInfo);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.game_mod = null;
    this.league = null;
    this.leaderboard = null;
    app.connection.on('arcade-game-info-render-request', function () {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this.open(obj);
    });
  }
  return _createClass(ArcadeGameInfo, [{
    key: "open",
    value: function open() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var game_name = obj.game || obj.moduleName || null;
      var league_id = obj.leagueId || obj.league_id || null;
      this.game_mod = game_name ? this.app.modules.returnModuleByName(game_name) : null;
      this.league = null;
      var league_mod = this.app.modules.returnModule('League');
      if (league_mod) {
        if (league_id) {
          this.league = league_mod.returnLeague(league_id);
        } else if (game_name) {
          var leagues = league_mod.returnLeaguesByGame(game_name) || [];
          if (leagues.length > 0) {
            this.league = leagues[0];
          }
        }
      }
      if (!this.game_mod && this.league) {
        this.game_mod = this.app.modules.returnModuleByName(this.league.game);
      }
      if (!this.game_mod) {
        console.warn('ArcadeGameInfo: game module not found', obj);
        return;
      }
      this.render();
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$mod,
          _this2 = this;
        var image, arcade_game, pack, is_teaser, title;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // Same artwork as the Arcade teaser/card (Game.image), never the banner.
              image = '';
              arcade_game = (_this$mod = this.mod) === null || _this$mod === void 0 || (_this$mod = _this$mod.games) === null || _this$mod === void 0 ? void 0 : _this$mod.find(function (g) {
                return g.name === _this2.game_mod.name;
              });
              if (arcade_game !== null && arcade_game !== void 0 && arcade_game.image) {
                image = arcade_game.image;
              } else {
                try {
                  pack = this.game_mod.respondTo('arcade-games') || {};
                  is_teaser = this.game_mod.teaser === true || this.game_mod.is_teaser === true;
                  image = is_teaser ? this.game_mod.img || pack.image || '' : pack.image || this.game_mod.img || '';
                } catch (_) {}
              }
              title = this.game_mod.returnName ? this.game_mod.returnName() : this.game_mod.name;
              this.overlay.show(ArcadeGameInfoTemplate({
                title: title,
                image: image,
                hasLeaderboard: !!this.league
              }));
              if (image) {
                this.overlay.setBackground(image);
              }
              if (!this.league) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.mountLeaderboard();
            case 1:
              this.attachEvents();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "mountLeaderboard",
    value: function () {
      var _mountLeaderboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var mount, league_mod, Leaderboard, score, headers;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              mount = document.querySelector('.arcade-game-info .leaderboard');
              if (!(!mount || !this.league)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              league_mod = this.app.modules.returnModule('League');
              if (league_mod) {
                _context2.n = 2;
                break;
              }
              mount.innerHTML = '';
              return _context2.a(2);
            case 2:
              Leaderboard = require('../../../../league/lib/leaderboard');
              this.leaderboard = new Leaderboard(this.app, league_mod, '.arcade-game-info .leaderboard', this.league);
              _context2.n = 3;
              return this.leaderboard.render();
            case 3:
              // Arcade overlay presentation only — leave League's own UI unchanged.
              score = document.querySelector('.arcade-game-info .league-score-header');
              if (score) {
                score.onclick = null;
              }
              headers = document.querySelectorAll('.arcade-game-info .saito-table-header > div');
              if (headers[3]) {
                headers[3].textContent = 'Games';
              }
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function mountLeaderboard() {
        return _mountLeaderboard.apply(this, arguments);
      }
      return mountLeaderboard;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var create_btn = document.querySelector('.arcade-game-info [data-action="create"]');
      if (!create_btn) {
        return;
      }
      create_btn.onclick = function (e) {
        var _this3$league;
        e.preventDefault();
        _this3.overlay.remove();
        var payload = {
          game: _this3.game_mod.name
        };
        if ((_this3$league = _this3.league) !== null && _this3$league !== void 0 && _this3$league.admin) {
          payload.league = _this3.league;
        } else {
          payload.skip = 1;
        }
        _this3.app.connection.emit('arcade-launch-game-wizard', payload);
      };
    }
  }]);
}();
module.exports = ArcadeGameInfo;